import { gql } from '@apollo/client'

export const CREATE_ONE_BOOKMARK = gql`
  mutation createOneBookmark($text: String!, $timecode: Float!, $shiurId: String!) {
    createOneBookmark(text: $text, timecode: $timecode, shiurId: $shiurId) {
      bookmarkId
    }
  }
`
